const CONTENT_SEGMENTS = Object.freeze({
  STANDARD: 'blog',
  VIDEO: 'video',
  QUIZ: 'quiz',
  POLL: 'poll',
  ARTICLE: 'newspaper',
});

export const getCanonicalContentPath = (post) => {
  const type = String(post?.type || post?.postType || '').toUpperCase();
  const segment = CONTENT_SEGMENTS[type] || (String(post?.type || '').toLowerCase() === 'post' ? 'blog' : 'blog');
  const identifier = post?.publicId ?? post?.id;
  return identifier == null ? '/' : `/${segment}/${identifier}`;
};

export const getCanonicalContentUrl = (post, origin = window.location.origin) => (
  new URL(getCanonicalContentPath(post), origin).toString()
);

// Compatibility for bookmarks and external legacy links. URL normalization is
// not a second screen: retain parameters/history state and skip its animation.
export function replaceCanonicalLocation(navigate, pathname) {
  if (window.location.pathname === pathname) return;
  navigate(`${pathname}${window.location.search}${window.location.hash}`, {
    replace: true,
    state: { ...window.history.state?.usr, __amposterCanonicalFrom: window.location.pathname },
  });
}

const CONTENT_DETAIL_PATH = /^\/(?:post|blog|video|quiz|poll|newspaper)\/[^/]+\/?$/i;
const DIRECT_ENTRY_MARKER = '__amposterDirectContentEntry';
const FEED_FALLBACK_MARKER = '__amposterFeedFallback';

// A fresh browser/PWA launch has no React Router history index. Put the feed
// immediately behind the deep link so the first Back reveals the app instead
// of closing it. Internal navigations already have an index and are untouched.
export const prepareDirectContentHistory = (browserWindow = window) => {
  const { history, location } = browserWindow;
  if (!CONTENT_DETAIL_PATH.test(location.pathname)) return false;
  const state = history.state || {};
  if (state[DIRECT_ENTRY_MARKER] || (typeof state.idx === 'number' && state.idx > 0)) return false;

  const deepLink = `${location.pathname}${location.search}${location.hash}`;
  history.replaceState({ idx: 0, [FEED_FALLBACK_MARKER]: true }, '', '/');
  history.pushState({ ...state, idx: 1, [DIRECT_ENTRY_MARKER]: true }, '', deepLink);
  return true;
};

export { CONTENT_DETAIL_PATH };
